/* eslint-disable camelcase */
import * as mutationTypes from './mutationTypes';

const mutations = {
  [mutationTypes.FETCH_CAMPAIGNS](state) {
    state.fetchingCampaigns = true;
    state.campaigns = [];
    state.errorFetchingCampaigns = null;
  },
  [mutationTypes.DONE_FETCHING_CAMPAIGNS](state, campaigns) {
    state.fetchingCampaigns = false;
    state.campaigns = campaigns;
  },
  [mutationTypes.ERROR_FETCHING_CAMPAIGNS](state, { error }) {
    state.fetchingCampaigns = false;
    state.errorFetchingCampaigns = error;
  },

  [mutationTypes.FETCH_CAMPAIGN](state) {
    state.fetchingCampaign = true;
    state.errorFetchingCampaign = null;
  },
  [mutationTypes.DONE_FETCHING_CAMPAIGN](state, campaign) {
    state.fetchingCampaign = false;
    state.campaign = campaign;
  },
  [mutationTypes.ERROR_FETCHING_CAMPAIGN](state, { error }) {
    state.fetchingCampaign = false;
    state.errorFetchingCampaign = error;
  },

  [mutationTypes.CREATE_CAMPAIGN](state) {
    state.errorCreatingCampaign = null;
    state.creatingCampaign = true;
    state.lastCreatedCampaign = null;
  },
  [mutationTypes.DONE_CREATING_CAMPAIGN](state, { campaign }) {
    state.creatingCampaign = false;
    state.lastCreatedCampaign = campaign;
  },
  [mutationTypes.ERROR_CREATING_CAMPAIGN](state, { error }) {
    state.errorCreatingCampaign = error;
    state.creatingCampaign = false;
  },
  [mutationTypes.SET_CAMPAIGN_IN_CREATION_USECASE](state, { usecase }) {
    state.campaignInCreationUseCase = usecase;
  },

  [mutationTypes.UPDATE_SAMPLE_MESSAGES](state) {
    state.errorUpdatingSampleMessages = null;
    state.updatingSampleMessages = true;
  },
  [mutationTypes.DONE_UPDATING_SAMPLE_MESSAGES](state, { campaign }) {
    state.updatingSampleMessages = false;
    state.campaign = campaign;
  },
  [mutationTypes.ERROR_UPDATING_SAMPLE_MESSAGES](state, { error }) {
    state.errorUpdatingSampleMessages = error;
    state.updatingSampleMessages = false;
  },

  [mutationTypes.DELETE_CAMPAIGN](state) {
    state.errorDeletingCampaign = null;
    state.deletingCampaign = true;
  },
  [mutationTypes.DONE_DELETING_CAMPAIGN](state, { campaign, showCampaignList }) {
    state.deletingCampaign = false;
    state.deletedCampaign = campaign;
    if (!showCampaignList) state.campaign = campaign;
  },
  [mutationTypes.ERROR_DELETING_CAMPAIGN](state, { error }) {
    state.errorDeletingCampaign = error;
    state.deletingCampaign = false;
  },

  [mutationTypes.QUALIFY_BRAND](state) {
    state.errorQualifyingBrand = null;
    state.qualification = null;
    state.qualifyingBrand = true;
  },
  [mutationTypes.DONE_QUALIFYING_BRAND](
    state,
    { qualification, sampleMessagesMin, contentAttributesRequired, qualified }
  ) {
    state.qualifyingBrand = false;
    state.qualified = qualified;
    state.qualification = qualification;
    state.sampleMessagesMin = sampleMessagesMin;
    state.contentAttributesRequired = contentAttributesRequired;
  },
  [mutationTypes.ERROR_QUALIFYING_BRAND](state, { error }) {
    state.errorQualifyingBrand = error;
    state.qualifyingBrand = false;
  },
  [mutationTypes.REMOVE_CREATION_ERRORS](state, { key } = {}) {
    if (!!state.errorCreatingCampaign && typeof state.errorCreatingCampaign === 'object') {
      state.errorCreatingCampaign[key] = null;
      if (Object.keys(state.errorCreatingCampaign).some(errKey => !!state.errorCreatingCampaign[errKey])) return;
    }
    state.errorCreatingCampaign = null;
  },
  [mutationTypes.REMOVE_UPDATE_ERRORS](state, { key }) {
    state[key] = null;
  },
  [mutationTypes.REMOVE_LAST_CREATED_CAMPAIGN](state) {
    state.lastCreatedCampaign = null;
  },

  // NUMBER LINKING
  [mutationTypes.HANDLE_NUMBER_LINK](state) {
    state.handlingNumberLink = true;
    state.errorHandlingNumberLink = undefined;
  },

  [mutationTypes.CLEAR_NUMBERS](state) {
    state.errorHandlingNumberLink = undefined;
    state.numbersMap = {};
  },

  [mutationTypes.CLEAR_ERROR_HANDLING_NUMBERS](state) {
    state.errorHandlingNumberLink = undefined;
  },

  [mutationTypes.DONE_HANDLING_NUMBER_LINK](state) {
    state.handlingNumberLink = false;
    state.campaign.linkedNumbersCount += 1;
  },

  [mutationTypes.DONE_HANDLING_NUMBER_UNLINK](state) {
    state.handlingNumberLink = false;
    state.campaign.linkedNumbersCount -= 1;
  },

  [mutationTypes.ERROR_HANDLING_NUMBER_LINK](state, { error }) {
    state.errorHandlingNumberLink = error;
    state.handlingNumberLink = false;
  },

  [mutationTypes.ADD_LINKED_CAMPAIGN](state, { campaign_id, brand_id, label }) {
    state.linkedCampaigns = {
      ...state.linkedCampaigns,
      [`${brand_id}${campaign_id}`]: { brandId: brand_id, id: campaign_id, label },
    };
  },

  [mutationTypes.RESET_FORM](state) {
    state.qualification = null;
    state.errorQualifyingBrand = null;
    state.sampleMessagesMin = 1;
    state.qualified = true;
    state.contentAttributesRequired = {};
  },
  [mutationTypes.REMOVE_LAST_DELETED_CAMPAIGN](state) {
    state.deletedCampaign = null;
  },
  [mutationTypes.REMOVE_DELETION_ERROR](state) {
    state.errorDeletingCampaign = null;
  },
};

export default mutations;
